import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import Dropdown from "react-bootstrap/Dropdown";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import MemberIconNew from "../member-icon-new/member-icon-new";
import MemberDropdownProject from "../member-dopdown-project/member-dropdown-project";
import PlusIconPanelNew from "../plus-icon/Plus-Icon-Panel-New.jsx";
import PlusIcon from "../plus-icon/Plus-Icon";
import "./view-members-projects.scss";

const ViewMembersPanelProject = ({
  UserID,
  members,
  taskCreator,
  taskType,
  projects,
  projectsUsers,
  projectsGroups,
  onEdit,
  isGroup,
  textChange = false,
  memberAddDisabled,
  isHidden = false,
}) => {
  const [user, setUser] = useState({}); //stores the owner object
  const [extraMembers, setExtraMembers] = useState(members?.length > 0 ? members.length - 3 : 0); //amount of extraMembers
  const [ownerShown, setOwnerShown] = useState(false);
  const [plusPosition, setPlusPosition] = useState(0);
  const [nameClass, setNameClass] = useState("");
  const [showPlusPanel, setShowPlusPanel] = useState(false);
  const [membersCount, setMembersCount] = useState(0);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMembersTooltipVisible, setIsMembersTooltipVisible] = useState(false);
  const [ownerGroup, setOwnerGroup] = useState(null);
  // Default user
  const [MembersShown, setMembersShown] = useState([
    {
      approve: false,
      assign: false,
      createdDate: "0001-01-01T00:00:00",
      isActive: false,
      publish: false,
      userID: 0,
      userName: "Z",
      userNameFull: "Z Z",
      User: { Name: "Z Z" }, //-- Change all the names here
      view: false,
    },
  ]);
  const [MembersOnPanel, setMembersOnPanel] = useState([
    {
      approve: false,
      assign: false,
      createdDate: "0001-01-01T00:00:00",
      isActive: false,
      publish: false,
      userID: 0,
      userName: "Z",
      userNameFull: "Z Z",
      User: { Name: "Z Z" }, //--
      view: false,
    },
  ]);
  const [position, setNewPosition] = useState([
    "first-icon",
    "second-icon",
    "third-icon",
    "fourth-icon",
    "fifth-icon",
  ]); //array that stores the classNames of all the icon positions

  useEffect(() => {
    if (members?.length > 0) {
      initialFunction();
      setExtraMembers(members?.length > 0 ? members.length - 3 : 0);
    }
  }, [members]);

  useEffect(() => {
    setGroupsOwner();
  }, [projectsGroups]);

  const setGroupsOwner = () => {
    const temp = projectsGroups?.find((group) => group.IsOwner);
    if (temp?.length > 0) setOwnerGroup(temp[0]);
  };

  const FindClassName = (length) => {
    if (length <= 3) {
      return "show-member-panel";
    } else if (projects) {
      return "show-member-panel-projects";
    } else if (length === 4) {
      return "show-member-panel-tasks-1";
    } else {
      return "show-member-panel-tasks";
    }
  };

  const initialFunction = () => {
    const newUser = members.find((member) => member.UserId === UserID);
    let newMembersList = [];
    let newMembersShown = [];
    let count = 0;
    if (newUser) {
      setUser(newUser);
      newMembersList = members.filter((member) => member.UserId !== UserID);
      setOwnerShown(true);
    } else {
      newMembersList = members;
      setOwnerShown(false);
    }

    newMembersShown = newMembersList.sort((a, b) => {
      const nameStringA = a.User?.Name || a.Name || "";
      const nameStringB = b.User?.Name || b.Name || "";
      const name1 = nameStringA.split(" ");
      const name2 = nameStringB.split(" ");
      const compareFirstNames = name1[0].localeCompare(name2[0]);
      if (compareFirstNames !== 0) return compareFirstNames;
      if (name1.length > 1 && name2.length > 1) return name1[1].localeCompare(name2[1]);
      return 0;
    });

    if (newUser) newMembersShown.unshift(newUser);

    if (projects) {
      setNameClass("-projects");
      setPlusPosition(Math.min(newMembersShown.length, 4));
      setMembersShown(newMembersShown);

      let updatedMembersShown = [];
      for (let i = 0; i < newMembersShown.length; i++) {
        if (
          typeof newMembersShown[i]?.Group?.Members !== "undefined" &&
          newMembersShown[i]?.Group?.Members !== null
        ) {
          count += newMembersShown[i].Group.Members.length;
        } else {
          count++;
        }

        updatedMembersShown.push(newMembersShown[i]);
      }
      setMembersOnPanel(updatedMembersShown);
      setMembersCount(count);
    } else {
      setMembersOnPanel(newMembersShown);
      setMembersShown(newMembersShown);
    }
  };

  const closePlusPanel = () => setShowPlusPanel(false);

  const popperConfig = {
    placement: "bottom-end",
    strategy: "fixed",
  };

  return (
    <div>
      <Dropdown
        drop={"down"}
        className="removeArrow"
        onMouseLeave={() => setShowDropdown(false)}
        onMouseOver={() => setShowDropdown(true)}
        onClick={(e) => e.nativeEvent.stopImmediatePropagation()}
      >
        <Dropdown.Toggle
          as={"div"}
          className={`member-dropdown-toggle${nameClass}`}
          onClick={(e) => e.nativeEvent.stopImmediatePropagation()}
        >
          {
            <div>
              { ownerGroup &&
                <div className={`first-icon`}>
                  {
                    <MemberIconNew
                      member={ownerGroup}
                      type={"user"}
                      isGroup={true}
                    />
                  }
                </div>
              }
              { ownerGroup && !ownerShown &&
                <div className={`second-icon`}>
                  {
                    <MemberIconNew
                      member={taskCreator}
                      type={"creator"}
                      isGroup={true}
                    />
                  }
                </div>
              }
              { MembersShown && MembersShown.slice(0, 4).map((entry, index) => (
                <div
                  key={index}
                  className={
                    ownerGroup
                      ? !ownerShown
                        ? `ownerGroup ${position[index + 2]}`
                        : `ownerGroup ${position[index + 1]}`
                      : `${position[index]}`
                  }
                >
                  { index === 0 && ownerShown && ownerGroup == null
                    ? <MemberIconNew member={entry} type={"user"} />
                    : index === 3 && extraMembers > 0
                      ? <MemberIconNew member={entry} extraMembers={extraMembers} type={"extra"} />
                      : index === 0 && ownerShown && ownerGroup
                        ? <div className="creatorMemberContainer">
                            <MemberIconNew member={entry} type={"creator"} />
                          </div>
                        : <MemberIconNew member={entry} type={"default"} />
                  }
                </div>
                ))
              }
            </div>
          }
        </Dropdown.Toggle>
        <Dropdown.Menu
          popperConfig={popperConfig}
          show={showDropdown}
          style={{ width: `${projects ? "320px" : "272px"}` }}
          className={FindClassName(members?.length ? members.length : 0)}
          drop-dropup-auto="false"
        >
          <div className={"member-dropdown-row-header"}>
            <div className={"member-dropdown-title-text"}>
              {textChange ? "Actionable by" : "View Members/Groups"}
            </div>
          </div>
          <Dropdown.Divider style={{ width: `${projects ? "320px" : "272px"}` }} />
          <div className={"member-dropdown-body-wrapper"}>
            { ownerGroup && (
              <div>
                <MemberDropdownProject
                  member={ownerGroup}
                  taskType={taskType}
                  type={"user"}
                  filter={false}
                  toggleRow={() => {}}
                  selectedMembers={[]}
                  projects={projects}
                  isGroupOwner={true}
                  isUserAdminComponent={false}
                  ownerId={UserID}
                />
              </div>
            )}
            { ownerGroup && !ownerShown && (
              <div>
                <MemberDropdownProject
                  member={taskCreator}
                  taskType={taskType}
                  type={"creator"}
                  filter={false}
                  toggleRow={() => {}}
                  selectedMembers={[]}
                  projects={projects}
                  isGroupOwner={true}
                  isUserAdminComponent={false}
                  ownerId={UserID}
                />
              </div>
            )}
            { MembersOnPanel &&
              MembersOnPanel.map((entry, index) =>
                index === 0 && ownerShown && ownerGroup == null ?
                  <div key={index}>
                    <MemberDropdownProject
                      member={isGroup ? { ...entry, GroupId: null } : entry}
                      taskType={taskType}
                      type={"user"}
                      filter={false}
                      toggleRow={() => {}}
                      selectedMembers={[]}
                      projects={projects}
                      isGroupOwner={false}
                      isUserAdminComponent={false}
                      ownerId={UserID}
                    />
                  </div>
                :
                  <div key={index}>
                    <Dropdown.Divider
                      style={{
                        width: `${projects ? "290px" : "240px"}`,
                        marginLeft: "15px",
                        "border-bottom": `${
                          (index == 1 && ownerShown && ownerGroup) ||
                          (index == 0 && !ownerShown && ownerGroup)
                            ? "1px solid #8A8886"
                            : ""
                        }`,
                      }}
                    />
                    <MemberDropdownProject
                      member={isGroup ? { ...entry, GroupId: null } : entry}
                      taskType={taskType}
                      type={index == 0 && ownerShown ? "creator" : ""}
                      filter={false}
                      toggleRow={() => {}}
                      selectedMembers={[]}
                      projects={projects}
                      isGroupOwner={false}
                      isUserAdminComponent={false}
                      ownerId={UserID}
                    />
                  </div>
               )
              }
          </div>
        </Dropdown.Menu>
      </Dropdown>
      { projects && !isHidden &&
        <div className={`member-plus`}>
          <div className={`member-dropdown-toggle-plus`}>
            {  !memberAddDisabled ?
              <React.Fragment>
                <OverlayTrigger
                  placement="bottom-end"
                  overlay={
                    <Tooltip>
                      You don't have access to edit projects. Please contact
                      administration for assistance.
                    </Tooltip>
                  }
                >
                  <div className={`${position[plusPosition]}`}>
                    <PlusIcon
                      func={() => setShowPlusPanel(true)}
                      active={showPlusPanel}
                      disabled={!memberAddDisabled}
                    />
                    { showPlusPanel &&
                      <PlusIconPanelNew
                        userID={UserID}
                        projects={projects}
                        onEdit={onEdit}
                        usersMembers={projectsUsers}
                        groupsMembers={projectsGroups}
                        selectedMembers={[...MembersShown]}
                        close={closePlusPanel}
                        ownerId={UserID}
                      />
                    }
                  </div>
                </OverlayTrigger>
              </React.Fragment>
            :
              <div className={`${position[plusPosition]}`}>
                <OverlayTrigger
                  placement="bottom"
                  show={isMembersTooltipVisible && !showPlusPanel}
                  trigger={["hover", "hover"]}
                  onToggle={(toggle) => {
                    setIsMembersTooltipVisible(toggle);
                  }}
                  overlay={<Tooltip>Add Member</Tooltip>}
                >
                  <div>
                    <PlusIcon
                      className="bg-dark"
                      func={() => setShowPlusPanel(true)}
                      active={showPlusPanel}
                      disabled={!memberAddDisabled}
                    />
                  </div>
                </OverlayTrigger>
                { showPlusPanel &&
                  <PlusIconPanelNew
                    userID={UserID}
                    projects={projects}
                    onEdit={onEdit}
                    usersMembers={projectsUsers}
                    groupsMembers={projectsGroups}
                    selectedMembers={[...MembersShown]}
                    close={closePlusPanel}
                    ownerId={UserID}
                  />
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  );
};

ViewMembersPanelProject.propTypes = {
  members: PropTypes.array.isRequired,
  projectsUsers: PropTypes.array.isRequired,
  projectsGroups: PropTypes.array.isRequired,
  UserID: PropTypes.string.isRequired,
  projects: PropTypes.bool.isRequired,
  taskCreator: PropTypes.object,
  MembersOnPanel: PropTypes.array,
  isGroup: PropTypes.bool.isRequired,
  taskType: PropTypes.string.isRequired,
  isHidden: PropTypes.bool.isRequired,
  memberAddDisabled: PropTypes.bool.isRequired,
  onEdit: PropTypes.func,
  textChange: PropTypes.bool,
};

export default ViewMembersPanelProject;
